import { Message } from '@/types/discover';

/** 버블 레이아웃 컨테이너 */
interface LayoutContainerBubblesProps {
  children: React.ReactNode;
  data: Message;
}

const LayoutContainerBubbles = ({ children, data }: LayoutContainerBubblesProps) => {
  let layoutClass = 'mb-[20px]';

  switch (data.sender) {
    case 'user':
      layoutClass += ' justify-end';
      break;
    case 'alert':
      layoutClass += ' justify-center mb-[0px]';
      break;
    case 'bot':
    default:
      layoutClass += ' justify-start';
      break;
  }

  return (
    <div key={data.id} className={`flex ${layoutClass}`}>
      {children}
    </div>
  );
};

export default LayoutContainerBubbles;
